<pb-header>
    @if (sessionStorage.getItem('selectedFknKey')) {
    <p class="color-text-tertiary">{{ 'HEADER.' + getAppThemeName() + '.bcn' | translate }}: {{sessionStorage.getItem('selectedFknKey')}}</p>
    }
</pb-header>
